const firestore = {
  firestorePath: '/products',
  firestoreRefType: 'collection',
  moduleName: 'products',
  statePropName: 'products',
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: '%convertTimestamp%',
      updated_at: '%convertTimestamp%'
    }
  },
  sync: {
    debounceTimerMs: 1
  }
};

export default firestore

